module.exports = __webpack_public_path__ + "media/send.a9d1cfa6.mp3";